import React, { useCallback, useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { REELS_PLAN_CADENCES } from 'fym-shared/src/music24/reelsPlan';
import { TypedMemo } from '../../../../../common/types';
import type { ReelsPlanCadence } from '../../../../../../redux/api/fymAPI.types';
import { reelsPlanMessages } from './reelsPlanMessages';
import { ReelsPlanSegment } from './ReelsPlanSegment';

const CADENCE_LABEL: Record<ReelsPlanCadence, MessageDescriptor> = {
  daily: reelsPlanMessages.cadenceDaily,
  every2Days: reelsPlanMessages.cadenceEvery2Days,
  threeAWeek: reelsPlanMessages.cadenceThreeAWeek,
};

interface ReelsPlanCadencePickerProps {
  cadence: ReelsPlanCadence;
  disabled: boolean;
  onChange: (cadence: ReelsPlanCadence) => void;
}

/** "How often" of the setup (design rollout-plan f1): every day, every 2 days, 3 a week. */
const ReelsPlanCadencePickerComponent: React.FC<ReelsPlanCadencePickerProps> = ({ cadence, disabled, onChange }) => {
  const intl = useIntl();
  const options = useMemo(
    () => REELS_PLAN_CADENCES.map((one) => ({ value: one, label: intl.formatMessage(CADENCE_LABEL[one]) })),
    [intl]
  );
  const pick = useCallback(
    (value: string) => {
      const next = REELS_PLAN_CADENCES.find((one) => one === value);
      if (next !== undefined) {
        onChange(next);
      }
    },
    [onChange]
  );
  return (
    <ReelsPlanSegment
      label={intl.formatMessage(reelsPlanMessages.cadence)}
      options={options}
      value={cadence}
      disabled={disabled}
      onChange={pick}
    />
  );
};

export const ReelsPlanCadencePicker = TypedMemo(ReelsPlanCadencePickerComponent);
